import { useMutation } from "@apollo/client";
import { DeleteSavedCourseDocument } from "./graphql/DeleteSavedCourse.v4.generated.js";
const useDeleteCourse = ()=>{
    const [deleteCourseMutation] = useMutation(DeleteSavedCourseDocument, {
        context: {
            clientName: 'v4'
        }
    });
    const deleteCourse = (courseId, enrollmentId)=>deleteCourseMutation({
            variables: {
                course_id: courseId,
                enrollment_id: enrollmentId
            }
        }).then((response)=>!!response.data?.deleteSavedCourse?.success);
    return {
        deleteCourse
    };
};
const useDeleteCourse_useDeleteCourse = useDeleteCourse;
export default useDeleteCourse_useDeleteCourse;
